export default {
  button: {
    backgroundColor: '#65554D',
    borderColor: '#65554D',
  },
};
